/*!

=========================================================
* Black Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// reactstrap components
import {
  Button,
  Modal,
  ModalBody,
  Card,
  CardHeader,
  CardBody,
  CardText,
  Collapse
} from "reactstrap";
//redux components
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class WatchUserModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        openedCollapses: [],
        userView: {},
        openedCollapsesVersions: [],
    };
  }

  componentDidMount() {
    const {  } = this.props;
  }

  componentDidUpdate(prevProps, prevState) {
    const { user } = this.props;
  }

  collapsesToggle = (e, collapse) => {
    e.preventDefault();
    let openedCollapses = this.state.openedCollapses;
    if (openedCollapses.includes(collapse)) {
      this.setState({
        openedCollapses: openedCollapses.filter(item => item !== collapse)
      });
    } else {
      openedCollapses.push(collapse);
      this.setState({
        openedCollapses: openedCollapses
      });
    }
  };

  collapsesToggleVersions = (e, collapse) => {
    e.preventDefault();
    let openedCollapses = this.state.openedCollapsesVersions;
    if (openedCollapses.includes(collapse)) {
      this.setState({
        openedCollapsesVersions: openedCollapses.filter(item => item !== collapse)
      });
    } else {
      openedCollapses.push(collapse);
      this.setState({
        openedCollapsesVersions: openedCollapses
      });
    }
  };

  render() {
    const { 
        userView, 
        openedCollapses, 
        openedCollapsesVersions
    } = this.state;
    const { modalWatchUserData, toggleModalWatchUserData, user } = this.props;
    // console.log(user);
    return (
      <>
        <Modal
            isOpen={modalWatchUserData}
            toggle={toggleModalWatchUserData}
            size="lg"
        >
            <div className="modal-header justify-content-center">
                <button
                    aria-hidden={true}
                    className="close"
                    data-dismiss="modal"
                    type="button"
                    onClick={toggleModalWatchUserData}
                >
                    <i className="tim-icons icon-simple-remove" />
                </button>
                <h4 className="title title-up">User Data</h4>
            </div>
            <ModalBody className="text-left">
                <p>
                    <span style={{fontWeight: 700, marginRight: "5px"}}>Email: </span> {userView && userView.email ? userView.email : ""}
                </p>
                <p>
                    <span style={{fontWeight: 700, marginRight: "5px"}}>Organization: </span> {userView && userView.organization ? userView.organization : ""}
                </p>
                <p>
                    <span style={{fontWeight: 700, marginRight: "5px"}}>User Id: </span> {userView && userView.user_id ? userView.user_id : ""}
                </p>
                <p>
                    <span style={{fontWeight: 700, marginRight: "5px"}}>Models: </span>
                </p>
                <div
                    aria-multiselectable={true}
                    className="card-collapse"
                    id="accordion"
                    role="tablist"
                    style={{border: "1px solid #ccc", padding: "0.01em 10px", borderRadius: "5px"}}
                >
                {user && user.user_models && user.user_models.user_models && user.user_models.user_models.map((val, index) => {
                    return (
                        <Card className="card-plain" key={index} style={{borderTop: index !== 0 ? "1px solid #ccc" : null, borderRadius: "0px"}}>
                            <CardHeader role="tab">
                                <a
                                    aria-expanded={openedCollapses.includes(
                                        index
                                    )}
                                    href="#pablo"
                                    data-parent="#accordion"
                                    data-toggle="collapse"
                                    onClick={e => this.collapsesToggle(e, index)}
                                    style={{color: "#000"}}
                                >
                                    {val.model_name}{" "}
                                    <i className="tim-icons icon-minimal-down" style={{marginTop: "6px"}}/>
                                </a>
                            </CardHeader>
                            <Collapse
                                role="tabpanel"
                                isOpen={openedCollapses.includes(
                                    index
                                )}
                            >
                                <CardBody style={{color: "#000", border: "1px solid #ccc", padding: "10px", borderRadius: "5px", marginBottom: "5px"}}>
                                    <p>
                                        <span style={{fontWeight: 700, marginRight: "5px"}}>Description: </span>{val.description}
                                    </p>
                                    <p>
                                        <span style={{fontWeight: 700, marginRight: "5px"}}>Routing Table: </span>
                                    </p>
                                    {val.routing_table && Object.keys(val.routing_table).length !== 0 ? Object.keys(val.routing_table).map((value_aux, j) => {
                                        return (
                                            <div key={j} style={{marginLeft: "5px"}}>
                                                <span style={{fontWeight: 600, marginRight: "5px"}}>{value_aux + ": "}</span>{val.routing_table[value_aux]}
                                            </div>
                                        );
                                    }) : 
                                    <CardText tag="h6" style={{color: "#000", display: "flex", justifyContent: "center", alignItems: "center"}}>This model doesn't have any route</CardText>
                                    }
                                    <p>
                                        <span style={{fontWeight: 700, marginRight: "5px"}}>Versions: </span>
                                    </p>
                                    {val && val.versioning && val.versioning.length !== 0 ?
                                    <div
                                        aria-multiselectable={true}
                                        className="card-collapse"
                                        id="accordion"
                                        role="tablist"
                                        style={{border: "1px solid #ccc", padding: "0.01em 10px", borderRadius: "5px", backgroundColor: "#F0F0F0"}}
                                    >
                                        {val.versioning.map((val, i) => {
                                            return (
                                                <Card className="card-plain" key={i} style={{borderTop: i !== 0 ? "1px solid #ccc" : null, borderRadius: "0px"}}>
                                                    <CardHeader role="tab">
                                                        <a
                                                            aria-expanded={openedCollapsesVersions.includes(
                                                                i
                                                            )}
                                                            href="#pablo"
                                                            data-parent="#accordion"
                                                            data-toggle="collapse"
                                                            onClick={e => this.collapsesToggleVersions(e, i)}
                                                            style={{color: "#000"}}
                                                            // className="text-dec"
                                                        >
                                                        {val.version_name}{" "}
                                                            <i className="tim-icons icon-minimal-down" style={{marginTop: "6px"}}/>
                                                        </a>
                                                    </CardHeader>
                                                    <Collapse
                                                        role="tabpanel"
                                                        isOpen={openedCollapsesVersions.includes(
                                                            i
                                                        )}
                                                    >
                                                        <CardBody style={{color: "#000"}}>
                                                        <p>
                                                            <span style={{fontWeight: 700, marginRight: "5px"}}>Version Date: </span> {val.version_date}
                                                        </p>
                                                        <p>
                                                            <span style={{fontWeight: 700, marginRight: "5px"}}>Version Performance Metrics: </span>
                                                        </p>
                                                        {Object.keys(val.version_performance_metrics).length !== 0 ? Object.keys(val.version_performance_metrics).map((aux, j) => {
                                                            return (
                                                                <div key={j}>
                                                                    <span style={{fontWeight: 600, marginRight: "5px"}}>{aux + ": "}</span>{val.version_performance_metrics[aux]}
                                                                </div>
                                                                );
                                                            }) : 
                                                            <CardText tag="h6" style={{color: "#000", display: "flex", justifyContent: "center", alignItems: "center"}}>This model doesn't have any metrics</CardText>
                                                        }
                                                        </CardBody>
                                                    </Collapse>
                                                </Card>
                                            )}
                                        )}
                                    </div> :
                                    <h6 style={{textAlign: "center"}}>
                                        <span style={{color: "#000"}}>
                                            This model doesn't have versions
                                        </span>
                                    </h6>
                                    }
                                </CardBody>
                            </Collapse>
                        </Card>
                    )}
                )}
                {user && user.user_models && user.user_models.user_models && user.user_models.user_models.length === 0 &&
                    <h6 style={{textAlign: "center"}}>
                        <span style={{color: "#000"}}>
                            You don't have any models
                        </span>
                    </h6>
                }
                </div>
            </ModalBody>
            <div className="modal-footer">
                <Button
                    color="danger"
                    data-dismiss="modal"
                    type="button"
                    onClick={toggleModalWatchUserData}
                >
                    Close
                </Button>
            </div>
        </Modal>
      </>
    );
  }
}

function mapStateToProps({model, auth, user}){
  return{
      model,
      auth,
      user
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators(
      {  }, dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(WatchUserModal);